import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';

/**
 * Live updates over SSE (ADR-019). An event only names what changed; the client invalidates its
 * cache and reads the data again through the normal endpoints and their permissions.
 * Never add names, phone numbers or clinical content here.
 */
export const LIVE_ENTITIES = [
  'patient',
  'appointment',
  'visit',
  'service',
  'resource',
  'member',
  'sms',
  'sms_template',
  'inventory',
  'finance',
] as const;
export type LiveEntity = (typeof LIVE_ENTITIES)[number];

export const LiveEventSchema = z.strictObject({
  type: z.enum(['created', 'updated']),
  entity: z.enum(LIVE_ENTITIES),
  id: UuidSchema,
  at: IsoDateTimeSchema,
});
export type LiveEvent = z.infer<typeof LiveEventSchema>;

/** SSE event name of a change (the stream also sends `ready` once, and comments as heartbeats). */
export const LIVE_EVENT_NAME = 'change';
